import React from 'react'
import { useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import ReactHtmlParser from 'react-html-parser'

const ExternalModalBox = (props) => {
  return (
    <CModal
      alignment="center"
      size="xl"
      scrollable
      visible={props.externalPageModal}
      onClose={() => props.setExternalPageModal(false)}
    >
      <CModalHeader>
        <CModalTitle>Information</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div
          style={{
            position: 'relative',
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            maxWidth: '100%',
            background: '#000',
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
            src="https://www.youtube.com/embed/x90jqjcrM9k?si=JHJW5_WYLGWK1Lwh"
            allowFullScreen
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            // allowtransparency="true"
            title="Embedded Tour"
          ></iframe>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => props.setExternalPageModal(false)}>
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ExternalModalBox
